import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "login_popup_input" }
const _hoisted_2 = { class: "custom-label" }
const _hoisted_3 = {
  key: 0,
  class: "error-message"
}

import { computed, ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TimeInput',
  props: {
    label: {},
    required: { type: Boolean },
    modelValue: {},
    requiredMessage: {},
    invalidMessage: {},
    invalidHhMessage: {},
    invalidMmMessage: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const errorMessage = ref('')

const displayValue = computed(() => props.modelValue ?? '')

const normalizeValue = (value: string): string => {
  return Array.from(value.trim())
    .map((char) => {
      const code = char.codePointAt(0)

      if (code !== undefined && code >= 0xff10 && code <= 0xff19) {
        return String.fromCharCode(code - 0xff10 + 0x30)
      }

      if (char === '：' || char === ':') {
        return ':'
      }

      if (code !== undefined && code >= 0x30 && code <= 0x39) {
        return char
      }

      return ''
    })
    .join('')
    .trim()
}

const formatTime = (value: string): string => {
  const normalized = normalizeValue(value)

  const match = normalized.match(/^(\d{1,2}):?(\d{1,2})$/)

  if (!match) {
    console.log('normalized not match')
    return normalized
  }

  const hour = Number(match[1])
  const minute = Number(match[2])

  if (hour > 23 || minute > 59) {
    return `${String(hour)}:${String(minute)}`
  }

  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

const validateTime = (value: string): string => {
  let normalized = normalizeValue(value)

  if (!normalized) {
    return props.requiredMessage ?? ''
  }

  normalized = formatTime(normalized)
  if (!/^\d{2}:?\d{2}$/.test(normalized)) {
    return props.invalidMessage ?? ''
  }

  console.log('validateTime normalized', normalized)

  const [hourString, minuteString] = normalized.split(':')
  const hour = Number(hourString)
  const minute = Number(minuteString)

  if (hour > 23) {
    return props.invalidHhMessage ?? ''
  }

  if (minute > 59) {
    return props.invalidMmMessage ?? ''
  }

  return ''
}

const handleInput = (event: Event): void => {
  const target = event.target as HTMLInputElement
  const value = normalizeValue(target.value)

  emit('update:modelValue', value)
  errorMessage.value = ''
}

const handleBlur = (event: FocusEvent): void => {
  const target = event.target as HTMLInputElement
  const formatted = formatTime(target.value)
  console.log('formatted', formatted)
  target.value = formatted

  emit('update:modelValue', formatted)
  errorMessage.value = validateTime(formatted)
}

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.label), 1),
    _createVNode(_component_a_input, {
      class: _normalizeClass(["ant-input-custom time-input", _ctx.required === true ? 'ant-required' : '']),
      type: "text",
      value: displayValue.value,
      required: _ctx.required,
      maxlength: "5",
      placeholder: "HH:MM",
      onInput: handleInput,
      onBlur: handleBlur
    }, null, 8, ["class", "value", "required"]),
    (errorMessage.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(errorMessage.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})